<template>
  <div>
    <div class="d-flex flex-column-fluid">
      <!--begin::Container-->
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-lg-12 col-xl-12">
                <div
                  class="
                    card card-custom
                    gutter-b
                    bg-transparent
                    shadow-none
                    border-0
                  "
                >
                  <div
                    class="
                      card-header
                      align-items-center
                      border-bottom-dark
                      px-0
                    "
                  >
                    <div class="card-title mb-0">
                      <h3 class="card-label mb-0 font-weight-bold text-body">
                        Заказы
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="card card-custom gutter-b bg-white border-0">
                  <div class="card-body">
                    <div>
                      <div class="table-responsive" id="printableTable">
                        <div
                          id="sale_wrapper"
                          class="dataTables_wrapper no-footer"
                        >
                          <div class="dataTables_length" id="sale_length">
                            <label
                              >Показать
                              <select
                                name="sale_length"
                                class=""
                                v-model="limit"
                                v-on:change="fetchorders()"
                              >
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                              </select>
                              записей</label
                            >
                          </div>

                          <div id="sale_filter" class="dataTables_filter">
                            <label
                              >Поиск:<input
                                type="test"
                                class=""
                                placeholder=""
                                v-model="searchParameter"
                                @keyup="searchProducts()"
                            /></label>
                            <button v-if="this.searchParameter != ''" @click="clearSearch">Очистить</button>

                          </div>
                          <div class="row mt-4 mb-4 order-status-filter-row">
                            <div class="col-12">
                              <div
                                class="position-relative order-status-filter"
                                ref="statusFilter"
                              >
                                <button
                                  type="button"
                                  class="btn btn-white border d-flex align-items-center justify-content-between w-100 text-left status-filter-trigger"
                                  @click="toggleStatusDropdown"
                                >
                                  <span class="status-filter-trigger__text">
                                    {{ getStatusFilterSummary() }}
                                  </span>
                                  <i class="fa fa-angle-down"></i>
                                </button>

                                <div
                                  v-if="showStatusDropdown"
                                  class="card shadow-sm border-0 status-filter-menu"
                                >
                                  <div class="card-body p-3">
                                    <div class="mb-3">
                                      <strong class="text-body">Статусы заказов</strong>
                                    </div>

                                    <div class="status-filter-options">
                                      <label
                                        v-for="status in orderStatuses"
                                        :key="status.order_status_id"
                                        class="status-filter-option"
                                      >
                                        <input
                                          type="checkbox"
                                          :checked="isStatusSelected(status.order_status_id)"
                                          @change="toggleOrderStatus(status.order_status_id)"
                                        />
                                        <span>{{ formatOrderStatusLabel(status) }}</span>
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <table
                            id="sale"
                            class="display dataTable no-footer"
                            sale="grid"
                          >
                            <thead class="text-body">
                              <tr sale="row">
                                <th
                                  tabindex="0"
                                  rowspan="1"
                                  colspan="1"
                                  aria-label="sale: activate to sort column ascending"
                                  style="width: 95.5288px; cursor: pointer"
                                  @click="sorting('id')"
                                  :class="sortClass('id')"
                                >
                                  ID
                                </th>
                                <th
                                  tabindex="0"
                                  rowspan="1"
                                  colspan="1"
                                  aria-label="sale: activate to sort column ascending"
                                  style="cursor: pointer"
                                  @click="sorting('billing_last_name')"
                                  :class="sortClass('billing_last_name')"
                                >
                                  Клиент
                                </th>
                                  <th
                                  tabindex="0"
                                  rowspan="1"
                                  colspan="1"
                                  aria-label="sale: activate to sort column ascending"
                                  style="width: 95.5288px; cursor: pointer"
                                  @click="sorting('order_price')"
                                  :class="sortClass('order_price')"
                                >
                                  Сумма
                                </th>

                                <th
                                  tabindex="0"
                                  rowspan="1"
                                  colspan="1"
                                  aria-label="sale: activate to sort column ascending"
                                  style="width: 95.5288px; cursor: pointer"
                                  @click="sorting('created_at')"
                                  :class="sortClass('created_at')"
                                >
                                  Дата
                                </th>
                                <th
                                  tabindex="0"
                                  rowspan="1"
                                  colspan="1"
                                  aria-label="sale: activate to sort column ascending"
                                  style="width: 95.5288px; cursor: pointer"
                                  @click="sorting('payment_method')"
                                  :class="sortClass('payment_method')"
                                >
                                  Способ оплаты
                                </th>
                                  <th
                                  tabindex="0"
                                  rowspan="1"
                                  colspan="1"
                                  aria-label="sale: activate to sort column ascending"
                                  style="width: 95.5288px; cursor: pointer"
                                  @click="sorting('shipping_method_id')"
                                  :class="sortClass('shipping_method_id')"
                                >
                                  Метод доставки
                                </th>
                                  <th
                                      tabindex="0"
                                      rowspan="1"
                                      colspan="1"
                                      aria-label="sale: activate to sort column ascending"
                                      style="width: 95.5288px; cursor: pointer"
                                      @click="sorting('order_status_id')"
                                      :class="sortClass('order_status_id')"
                                  >
                                      Статус
                                  </th>
                                <th style="width: 20px">
                                  Действие
                                </th>
                              </tr>
                            </thead>
                            <tbody class="kt-table-tbody text-dark">
                              <tr
                                class="kt-table-row kt-table-row-level-0 odd"
                                sale="row"
                                v-for="order in orders"
                                v-bind:key="order.order_id"
                              >
                                <td>
                                  {{ order.order_id }} {{(order.opencart_id)?'('+order.opencart_id+')':''}}

                                </td>
                                <td>
                                  {{ order.billing_first_name}} {{ order.billing_last_name}}
                                </td>
                                  <td>
                                  {{ order.order_price}} €
                                </td>
                                <td>
                                  {{ order.order_date_formatted }}
                                </td>
                                <td>
                                  {{ getPaymentMethodLabel(order) }}
                                </td>
                                <td>
                                  {{ getShippingMethodLabel(order) }}
                                </td>
                                  <td>
                                      <select
                                          class="form-control form-control-sm order-status-select"
                                          v-model="order.order_status_id"
                                          @focus="rememberOrderStatus(order)"
                                          @change="updateOrderStatus(order)"
                                          style="min-width: 160px"
                                      >
                                        <option
                                            v-for="status in orderStatuses"
                                            :key="status.order_status_id"
                                            :value="status.order_status_id"
                                        >
                                          {{ formatOrderStatusLabel(status) }}
                                        </option>
                                      </select>
                                  </td>
                                <td style="display: flex; gap: 10px;">
                                  <a
                                    :href="'/admin/order/' + order.order_id"
                                    class="click-edit"
                                    id="click-edit1"
                                    data-toggle="tooltip"
                                    title=""
                                    data-placement="right"
                                    ><i class="fa fa-edit"></i
                                  ></a>
                                  <a
                                    href="#"
                                    @click="switchProcess(order.order_id, order.processed)"
                                    :title="order.processed ? 'Отменить проводку' : 'Провести'"
                                  >
                                    <i :class="order.processed ? 'fa fa-undo' : 'fa fa-check'"></i>
                                    </a>
                                  <a v-if="!order.processed" class="" href="#" @click="deleteOrders(order.order_id)"><i class="fa fa-trash"></i></a>
                                </td>
                              </tr>
                              <tr v-if="orders.length === 0">
                                <td colspan="8" class="text-center text-muted py-5 no-orders-row">
                                  Ничего не найдено
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <ul class="pagination pagination-sm m-0 float-right">
                            <li
                              v-bind:class="[
                                { disabled: !pagination.prev_page_url },
                              ]"
                            >
                              <a
                                class="page-link"
                                href="#"
                                @click="fetchorders(pagination.prev_page_url)"
                                >Предыдущая</a
                              >
                            </li>

                              <li class="disabled">
                                  <span class="page-link text-dark text-center" href="#">Стр {{ pagination.current_page }} из {{ pagination.last_page }}</span>
                                  <span class="page-link text-dark">Перейти на <input style="width:25px;border:1px solid #dee2e6;text-align: center;" type="text" v-model="pagination.current_page" @keyup="changePage()" /></span>
                              </li>

                            <li
                              v-bind:class="[
                                { disabled: !pagination.next_page_url },
                              ]"
                              class="page-item"
                            >
                              <a
                                class="page-link"
                                href="#"
                                @click="fetchorders(pagination.next_page_url)"
                                >Следующая</a
                              >
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="offcanvas offcanvas-right kt-color-panel p-5 kt_notes_panel"
      v-if="display_form"
      :class="display_form ? 'offcanvas-on' : ''"
    >
      <div
        class="
          offcanvas-header
          d-flex
          align-items-center
          justify-content-between
          pb-3
        "
      >
        <h4 class="font-size-h4 font-weight-bold m-0">Add sale</h4>
        <a
          href="#"
          class="
            btn btn-sm btn-icon btn-light btn-hover-primary
            kt_notes_panel_close
          "
          v-on:click="display_form = 0"
        >
          <svg
            width="20px"
            height="20px"
            viewBox="0 0 16 16"
            class="bi bi-x"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
            ></path>
          </svg>
        </a>
      </div>
      <form id="myform">
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label class="text-dark">Name </label>
              <input
                type="text"
                name="text"
                v-model="order.name"
                class="form-control"
              />
              <small
                class="form-text text-danger"
                v-if="errors.has('name')"
                v-text="errors.get('name')"
              ></small>
            </div>
            <div class="form-group">
              <label class="text-dark">Direction </label>
              <select v-model="order.direction">
                <option value="ltr">LTR</option>
                <option value="rtl">RTL</option>
              </select>
              <small
                class="form-text text-danger"
                v-if="errors.has('direction')"
                v-text="errors.get('direction')"
              ></small>
            </div>
            <div class="form-group">
              <label class="text-dark">Code </label>
              <input
                type="text"
                name="text"
                v-model="order.code"
                class="form-control"
              />
              <small
                class="form-text text-danger"
                v-if="errors.has('code')"
                v-text="errors.get('code')"
              ></small>
            </div>
            <div class="form-group">
              <label class="text-dark">Directory </label>
              <input
                type="text"
                name="text"
                v-model="order.directory"
                class="form-control"
              />
              <small
                class="form-text text-danger"
                v-if="errors.has('directory')"
                v-text="errors.get('directory')"
              ></small>
            </div>
            <div class="form-group">
              <input
                type="checkbox"
                name="text"
                v-model="order.is_default"
                id="is_default"
                class="form-check-input"
              />
              <label class="text-dark" for="is_default">Set as default </label>
              <small
                class="form-text text-danger"
                v-if="errors.has('is_default')"
                v-text="errors.get('is_default')"
              ></small>
            </div>
          </div>
        </div>
        <button type="button" @click="addUpdatesale()" class="btn btn-primary">
          Submit
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import ErrorHandling from "../../ErrorHandling";

export default {
  data() {
    return {
        timer:0,
      display_form: 0,
      orders: [],
      orderStatuses: [],
      selectedOrderStatusIds: [],
      defaultOrderStatusIds: [],
      showStatusDropdown: false,
      searchParameter: "",
      sortBy: "id",
      sortType: "DESC",
      limit: 10,
      error_message: "",
      edit: false,
      actions: false,
      pagination: {},
      request_method: "",
      is_default: "0",
      token: [],
      errors: new ErrorHandling(),
      csrf: document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content"),
    };
  },

  methods: {
    searchProducts(){
        if(this.timer){
            clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
            this.fetchorders();
        }, 1000)
    },
    changePage(){
      if(this.timer){
          clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
          if(this.pagination.current_page>this.pagination.last_page) {
              this.pagination.current_page = this.pagination.last_page
          } else if(this.pagination.current_page<1 || isNaN(this.pagination.current_page)) {
              this.pagination.current_page = 1
          }
          this.fetchorders('/api/admin/order?page='+this.pagination.current_page);
      }, 1000)
    },
    formatOrderStatusLabel(status) {
      if (!status) {
        return "";
      }

      if (status.detail && status.detail.length > 0) {
        return status.detail[0].name;
      }

      return status.order_status_code || "";
    },
    getOrderStatusLabel(status) {
      return this.formatOrderStatusLabel(status) || "-";
    },
    getPaymentMethodLabel(order) {
      if (
        order &&
        order.payment_method_detail &&
        order.payment_method_detail.payment_method_title
      ) {
        return order.payment_method_detail.payment_method_title;
      }

      return "-";
    },
    getShippingMethodLabel(order) {
      if (
        order &&
        order.shipping_method_detail &&
        order.shipping_method_detail.shipping_method_description &&
        order.shipping_method_detail.shipping_method_description.length > 0 &&
        order.shipping_method_detail.shipping_method_description[0].name
      ) {
        return order.shipping_method_detail.shipping_method_description[0].name;
      }

      return "-";
    },
    sortClass(column) {
      if (this.sortBy !== column) {
        return "sorting";
      }

      return this.sortType === "asc" || this.sortType === "ASC"
        ? "sorting_asc"
        : "sorting_desc";
    },
    getStatusFilterSummary() {
      if (this.selectedOrderStatusIds.length === 0) {
        return "Все статусы";
      }

      if (this.selectedOrderStatusIds.length === this.orderStatuses.length) {
        return "Все статусы";
      }

      const selectedLabels = this.orderStatuses
        .filter((status) =>
          this.selectedOrderStatusIds.includes(status.order_status_id)
        )
        .map((status) => this.formatOrderStatusLabel(status));

      if (selectedLabels.length <= 2) {
        return selectedLabels.join(", ");
      }

      return `Выбрано статусов: ${selectedLabels.length}`;
    },
    isCompletedStatus(status) {
      const code = ((status && status.order_status_code) || "").toLowerCase();
      const label = this.formatOrderStatusLabel(status).toLowerCase();

      return (
        code === "completed" ||
        label.includes("completed") ||
        label.includes("pabeigts") ||
        label.includes("заверш")
      );
    },
    getDefaultOrderStatuses(statuses) {
      const defaultStatuses = statuses.filter(
        (status) => !this.isCompletedStatus(status)
      );

      return defaultStatuses.length ? defaultStatuses : statuses;
    },
    isStatusSelected(statusId) {
      return this.selectedOrderStatusIds.includes(statusId);
    },
    toggleStatusDropdown() {
      this.showStatusDropdown = !this.showStatusDropdown;
    },
    toggleOrderStatus(statusId) {
      const alreadySelected = this.selectedOrderStatusIds.includes(statusId);

      if (alreadySelected) {
        this.selectedOrderStatusIds = this.selectedOrderStatusIds.filter(
          (id) => id !== statusId
        );
      } else {
        this.selectedOrderStatusIds = [...this.selectedOrderStatusIds, statusId];
      }

      this.fetchorders();
    },
    rememberOrderStatus(order) {
      order.previous_order_status_id = order.order_status_id;
    },
    updateOrderStatus(order) {
      const selectedStatus = this.orderStatuses.find(
        (status) => status.order_status_id == order.order_status_id
      );

      this.$parent.loading = true;
      axios
        .post(
          `/api/admin/order/${order.order_id}/status-update`,
          { order_status_id: order.order_status_id },
          this.token
        )
        .then((res) => {
          if (selectedStatus) {
            order.order_status = selectedStatus;
          }

          order.previous_order_status_id = order.order_status_id;
          this.$toaster.success(
            res.data.message || "Order status updated"
          );
        })
        .catch((err) => {
          if (typeof order.previous_order_status_id !== "undefined") {
            order.order_status_id = order.previous_order_status_id;
            const previousStatus = this.orderStatuses.find(
              (status) => status.order_status_id == order.previous_order_status_id
            );

            if (previousStatus) {
              order.order_status = previousStatus;
            }
          }

          console.log(err);
          if (err.response && err.response.data && err.response.data.message) {
            this.$toaster.error(err.response.data.message);
          } else {
            this.$toaster.error("Unable to update order status");
          }
        })
        .finally(() => (this.$parent.loading = false));
    },
    getSelectedOrderStatusIds() {
      if (this.selectedOrderStatusIds.length > 0) {
        return this.selectedOrderStatusIds;
      }

      return this.orderStatuses.map((status) => status.order_status_id);
    },
    extractPageNumber(page_url) {
      if (!page_url) {
        return null;
      }

      const matches = page_url.match(/[?&]page=(\d+)/);

      return matches ? matches[1] : null;
    },
    fetchOrderStatuses() {
      this.$parent.loading = true;
      return axios
        .get("/api/admin/order-status", {
          ...this.token,
          params: {
            limit: 100,
            sortBy: "id",
            sortType: "ASC",
          },
        })
        .then((res) => {
          this.orderStatuses = res.data.data || [];
          this.defaultOrderStatusIds = this.getDefaultOrderStatuses(
            this.orderStatuses
          ).map(
            (status) => status.order_status_id
          );
          this.selectedOrderStatusIds = [...this.defaultOrderStatusIds];
        })
        .finally(() => (this.$parent.loading = false));
    },
    handleDocumentClick(event) {
      const filter = this.$refs.statusFilter;

      if (!filter) {
        return;
      }

      if (!filter.contains(event.target)) {
        this.showStatusDropdown = false;
      }
    },
    fetchorders(page_url) {
      this.$parent.loading = true;
      let vm = this;
      const page = this.extractPageNumber(page_url);
      const config = {
        ...this.token,
        params: {
          limit: this.limit,
          searchParameter: this.searchParameter || undefined,
          sortBy: this.sortBy,
          sortType: this.sortType,
          orderStatusId: this.getSelectedOrderStatusIds(),
          page: page || undefined,
        },
      };

      axios
        .get("/api/admin/order", config)
        .then((res) => {
          this.orders = res.data.data;
          vm.makePagination(res.data.meta, res.data.links);
        })
          .finally(() => (this.$parent.loading = false));
    },
    sorting(sortBy) {
      if (this.sortBy === sortBy) {
        this.sortType =
          this.sortType == "asc" || this.sortType == "ASC" ? "desc" : "asc";
      } else {
        this.sortBy = sortBy;
        this.sortType = "asc";
      }

      this.fetchorders();
    },

    makePagination(meta, links) {
      let pagination = {
        current_page: meta.current_page,
        last_page: meta.last_page,
        next_page_url: links.next,
        prev_page_url: links.prev,
      };

      this.pagination = pagination;
    },
    deleteOrders(id) {
      if (confirm("Are You Sure?")) {
        this.$parent.loading = true;
        axios
          .delete(`/api/admin/order/${id}`, this.token)
          .then((res) => {
            if (res.data.status == "Success") {
              this.$toaster.success(res.data.message);
              this.fetchorders();
            }
          })
          .catch((err) => console.log(err))
          .finally(() => (this.$parent.loading = false));
      }
    },
    clearSearch(){
      this.searchParameter = "",
      this.fetchorders();
    },
    switchProcess(id, isProcessed) {
      this.$parent.loading = true;
      const endpoint = isProcessed ? 'unprocess' : 'process';
      axios
        .post(`/api/admin/order/${id}/${endpoint}`, {}, this.token)
        .then((res) => {
          this.$toaster.success(res.data.message);
          this.fetchorders();
        })
        .catch((err) => {
          console.log(err);
          if (err.response && err.response.data && err.response.data.message) {
            this.$toaster.error(err.response.data.message);
          }
        })
        .finally(() => (this.$parent.loading = false));
    }
  },
  mounted() {
    var token = localStorage.getItem("token");
    this.token = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    this.fetchOrderStatuses().finally(() => {
      this.fetchorders();
    });
    document.addEventListener("click", this.handleDocumentClick);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleDocumentClick);
  },
  props: ["loading"],
};
</script>

<style scoped>
.order-status-filter {
  max-width: 280px;
}

.order-status-filter-row {
  clear: both;
}

.status-filter-trigger {
  min-height: 34px;
  padding: 0.375rem 0.75rem;
  font-size: 14px;
}

.status-filter-trigger__text {
  display: inline-block;
  max-width: calc(100% - 24px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.status-filter-menu {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  width: 100%;
  min-width: 280px;
  z-index: 30;
}

.status-filter-options {
  max-height: 260px;
  overflow-y: auto;
  border: 1px solid #e5e5e5;
  border-radius: 0.42rem;
  padding: 12px;
  background: #fff;
}

.status-filter-option {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
  cursor: pointer;
  color: #3f4254;
}

.status-filter-option:last-child {
  margin-bottom: 0;
}

.status-filter-option input {
  margin: 0;
}
</style>
